// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invoice_overview_top_cards_title {
    font-size: 20px;
    font-weight: 400;
    color: #0D0A3D;
    margin-bottom: 14px;
}

.invoice_overview_top_cards_list {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: 20px;
}

.invoice_overview_top_cards_container {
    width: 100%;
    box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.082);
    border-radius: 7px;
    padding: 29px 38px;
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
}

.invoice_overview_top_cards_card_title {
    position: relative;
}

.invoice_overview_top_cards_card_title > div {
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background-color: rgba(139, 188, 188, 1);
    position: absolute;
    left: -20px;
    top: 2px;
}

.invoice_overview_top_cards_card_title > p {
    color: rgba(118, 116, 147, 1);
    font-size: 13px;
    font-weight: 700;
}

.invoice_overview_top_cards_container > div > h5 {
    font-size: 30px;
    font-weight: 700;
    margin-top: 7px;
    margin-bottom: 0;
}

.invoice_overview_top_cards_card_image {
    width: 68px;
    height: 68px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(118, 116, 147, 0.11);
    border-radius: 20px;
}

.invoice_overview_top_cards_card_image > img {
    height: 28px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Blocks/InvoiceOverviewTopCards/InvoiceOverviewTopCards.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,iDAAiD;IACjD,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;IACxC,kBAAkB;IAClB,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".invoice_overview_top_cards_title {\n    font-size: 20px;\n    font-weight: 400;\n    color: #0D0A3D;\n    margin-bottom: 14px;\n}\n\n.invoice_overview_top_cards_list {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    grid-gap: 20px;\n}\n\n.invoice_overview_top_cards_container {\n    width: 100%;\n    box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.082);\n    border-radius: 7px;\n    padding: 29px 38px;\n    background-color: #FFFFFF;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n}\n\n.invoice_overview_top_cards_card_title {\n    position: relative;\n}\n\n.invoice_overview_top_cards_card_title > div {\n    width: 11px;\n    height: 11px;\n    border-radius: 50%;\n    background-color: rgba(139, 188, 188, 1);\n    position: absolute;\n    left: -20px;\n    top: 2px;\n}\n\n.invoice_overview_top_cards_card_title > p {\n    color: rgba(118, 116, 147, 1);\n    font-size: 13px;\n    font-weight: 700;\n}\n\n.invoice_overview_top_cards_container > div > h5 {\n    font-size: 30px;\n    font-weight: 700;\n    margin-top: 7px;\n    margin-bottom: 0;\n}\n\n.invoice_overview_top_cards_card_image {\n    width: 68px;\n    height: 68px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: rgba(118, 116, 147, 0.11);\n    border-radius: 20px;\n}\n\n.invoice_overview_top_cards_card_image > img {\n    height: 28px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
